module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjYuMTcyMzQiIGhlaWdodD0iMTEuMDY4IiB2aWV3Qm94PSIwIDAgNi4xNzIzNCAxMS4wNjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGlkPSJWZWN0b3IgMTA0IiBkPSJNMC4zNTA0NzEgMTAuNzA3Nkw1LjY3MjM0IDUuNTg2ODdMMC4zNTA0NzEgMC4zNTY2MDlNNS42NzIzNCA1LjU4Njg3TDAuMzQ4NTE4IDEwLjcwNzYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/chevron.svg
// module id = 820
// module chunks = 0 1 2 3 4